import { render } from "./PayTrPayments.vue?vue&type=template&id=0376667f&ts=true"
import script from "./PayTrPayments.vue?vue&type=script&lang=ts"
export * from "./PayTrPayments.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__